import { render, staticRenderFns } from "./SparePartSubCategoryDialog.vue?vue&type=template&id=0c50e56d"
import script from "./SparePartSubCategoryDialog.vue?vue&type=script&lang=ts"
export * from "./SparePartSubCategoryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports